module.exports = __webpack_public_path__ + "assets/img/Customer-service-waiting.3a21996e.gif";